import { useState, useEffect } from 'react';
import { apiFetch } from '../lib/api';


/**
 * Active currency for the shop, resolved by the backend:
 * Meta ad account currency → saved Settings default → USD.
 * Meta charges budgets in the account currency, so only the displayed
 * symbol changes — never the amounts.
 */
export default function useCurrency(shop) {
  const [currency, setCurrency] = useState('USD');
  const [symbol, setSymbol] = useState('$');

  useEffect(() => {
    if (!shop) return;
    apiFetch(`/api/settings/currency`, {
      credentials: 'include',
    })
      .then(r => r.json())
      .then(d => {
        if (d.currency) setCurrency(d.currency);
        if (d.symbol) setSymbol(d.symbol);
      })
      .catch(() => {});
  }, [shop]);

  return { currency, symbol };
}
